import React from 'react';
import { ArrowUpDownIcon } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@components/ui/select';
import type { SortOption } from '../types';

interface SortDropdownProps {
  value: SortOption;
  onChange: (sort: SortOption) => void;
}

export const SortDropdown: React.FC<SortDropdownProps> = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onValueChange={v => {
        onChange(v as SortOption);
      }}
    >
      <SelectTrigger
        className="w-auto border-none bg-transparent shadow-none p-1 h-auto"
        aria-label="Sort posts"
      >
        <ArrowUpDownIcon className="w-5 h-5" aria-hidden="true" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="latest">Latest</SelectItem>
        <SelectItem value="most_uplifted">Most Uplifted</SelectItem>
        <SelectItem value="most_helpers">Most Helpers</SelectItem>
        <SelectItem value="most_relatable">Most Relatable</SelectItem>
        <SelectItem value="bookmarked">Bookmarked</SelectItem>
      </SelectContent>
    </Select>
  );
};
